// extracted by mini-css-extract-plugin
export default {"item":"ProjectItem_item__OEhQd","item_link":"ProjectItem_item_link__W5BqL","item_image":"ProjectItem_item_image__k1nNI","item_desc":"ProjectItem_item_desc__9J0eq"};